document.addEventListener('DOMContentLoaded', function() {
    let menuButton = document.getElementById('mobile-menu-button');
    let menu = document.getElementById('mobile-menu');

    menuButton.onclick = function(event) {
        menu.classList.toggle('opening');
    }

    // 予約セクションの表示を時期（7〜9月）に合わせて切り替え（JST基準）
    // - 7〜9月: 予約停止の案内
    // - 10〜6月: 通常予約の案内
    var octJunElm = document.getElementById('reserve-contact-oct-jun');
    var julSepElm = document.getElementById('reserve-contact-jul-sep');
    if (octJunElm && julSepElm) {
        // IE11等でも動くよう、Intl(timeZone) に頼らず UTC+9 で月を算出する
        var now = new Date();
        var utcMillis = now.getTime() + (now.getTimezoneOffset() * 60000);
        var tokyo = new Date(utcMillis + (9 * 60 * 60000));
        var month = tokyo.getMonth() + 1; // 1-12
        var isBusySeason = (month >= 7 && month <= 9);

        if (isBusySeason) {
            octJunElm.hidden = true;
            julSepElm.hidden = false;
        } else {
            octJunElm.hidden = false;
            julSepElm.hidden = true;
        }
    }
});

var scrollTop = function() {
    if ('scrollingElement' in document) {
        return document.scrollingElement.scrollTop;
    }
    return window.pageYOffset;
};

document.addEventListener('scroll', function(e) {
    let drone = document.getElementById('drone');

    //drone.classList.toggle("scroll-top-btn", scrollTop() > 100);
    if (scrollTop() > 100) {
        drone.classList.add("scroll-top-btn");
    } else {
        drone.classList.remove("scroll-top-btn");
    }
});

var parallaxTargets = [
    {trigger: 'about', target: 'inter-section-1-img'},
    {trigger: 'plan', target: 'inter-section-2-img'},
    {trigger: 'spot', target: 'inter-section-3-img'},
    {trigger: 'staff', target: 'inter-section-4-img'},
    {trigger: 'reserve', target: 'inter-section-5-img'},
];

document.addEventListener('scroll', function(e) {
    var scrollY = window.pageYOffset;

    var visibleImage = function(trigger, target) {
        var triggerElm = document.getElementById(trigger);
        var targetElm = document.getElementById(target);
    
        if(!triggerElm || !targetElm) return;
    
        var triggerRect = triggerElm.getBoundingClientRect();
        var triggerY = scrollY + triggerRect.top;
        if(scrollY > triggerY) {
            targetElm.classList.add('inter-section-visible');
        } else {
            targetElm.classList.remove('inter-section-visible');
        }
    }
    for (const elm of parallaxTargets) {
        visibleImage(elm.trigger, elm.target);
    }
});

var header = document.getElementById("header");
header.style.position = 'relative'; // for IE11

var objectFitImages = require('object-fit-images');
objectFitImages();
